(() => {
  const root = document.documentElement;
  const host = document.querySelector('#bb-tools-messages');
  if (!host) return;
  const messages = JSON.parse(host.textContent);
  const tools = document.querySelector('#bb-tools');
  const cookieDialog = document.querySelector('#bb-cookie-preferences');
  const banner = document.querySelector('[data-bb-cookie-banner]');
  const feedback = document.querySelector('[data-bb-feedback]');
  const loading = document.querySelector('[data-bb-page-loading]');
  const topButton = document.querySelector('[data-bb-top]');
  const progress = document.querySelector('[data-bb-progress]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let feedbackTimer;
  let loadingTimer;
  let privacyPromise;
  let returnFocus;
  const say = (text) => {
    clearTimeout(feedbackTimer);
    feedback.textContent = text;
    feedbackTimer = setTimeout(() => { feedback.textContent = ''; }, 6500);
  };
  const getScrollRoot = () => {
    const wrapper = document.querySelector('.page-wrapper');
    return wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : document.scrollingElement;
  };
  let scheduled = false;
  const updateScroll = () => {
    scheduled = false;
    const scroller = getScrollRoot();
    const max = scroller.scrollHeight - scroller.clientHeight;
    progress.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, scroller.scrollTop / max)) : 0})`;
    topButton.hidden = scroller.scrollTop < 500;
  };
  const scheduleScroll = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateScroll); }
  };
  document.addEventListener('scroll', scheduleScroll, { capture: true, passive: true });
  window.addEventListener('resize', scheduleScroll, { passive: true });
  new ResizeObserver(scheduleScroll).observe(document.querySelector('main'));
  updateScroll();
  const syncAppearance = () => document.querySelectorAll('[data-bb-dark]').forEach(button => button.setAttribute('aria-pressed', String(root.dataset.bbColor === 'dark')));
  syncAppearance();
  document.querySelectorAll('[data-bb-dock]').forEach(el => { el.hidden = false; });
  const showDialog = (dialog, trigger) => {
    if (!dialog.open) {
      returnFocus = trigger || document.activeElement;
      dialog.showModal();
    }
  };
  [tools, cookieDialog].forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true }); });
  });
  const privacy = () => {
    if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
    if (!privacyPromise) privacyPromise = new Promise((resolve, reject) => {
      if (!window.Shopify?.loadFeatures) { reject(new Error('Privacy unavailable')); return; }
      const timeout = setTimeout(() => reject(new Error('Privacy timeout')), 10000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        clearTimeout(timeout);
        if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Privacy unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      });
    }).catch(error => { privacyPromise = null; throw error; });
    return privacyPromise;
  };
  const cookieError = text => {
    document.querySelectorAll('[data-bb-cookie-error],[data-bb-banner-error]').forEach(el => { el.textContent = text; el.hidden = !text; });
  };
  const showPreferences = async trigger => {
    tools.close();
    if (window.privacyBanner?.showPreferences) {
      try { await window.privacyBanner.showPreferences(); return; } catch (_) {}
    }
    showDialog(cookieDialog, trigger);
    cookieError('');
    try {
      const api = await privacy();
      const consent = api.currentVisitorConsent();
      cookieDialog.querySelectorAll('[data-bb-consent]').forEach(input => { input.checked = consent[input.dataset.bbConsent] === 'yes'; });
    } catch (_) { cookieError(messages.privacy_error); }
  };
  const saveConsent = async action => {
    const buttons = [...document.querySelectorAll('[data-bb-consent-action]')];
    buttons.forEach(button => { button.disabled = true; });
    cookieError('');
    try {
      const api = await privacy();
      const consent = {};
      ['preferences', 'analytics', 'marketing'].forEach(key => { consent[key] = action === 'save' ? cookieDialog.querySelector(`[data-bb-consent="${key}"]`).checked : action === 'accept'; });
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('Consent timeout')), 10000);
        api.setTrackingConsent(consent, result => {
          clearTimeout(timeout);
          if (result?.error) { reject(new Error('Consent failed')); return; }
          const saved = api.currentVisitorConsent();
          if (Object.keys(consent).every(key => saved[key] === (consent[key] ? 'yes' : 'no'))) resolve();
          else reject(new Error('Consent not confirmed'));
        });
      });
      banner.hidden = true;
      cookieDialog.close();
      say(messages.preferences_saved);
    } catch (_) { cookieError(messages.privacy_error); }
    finally { buttons.forEach(button => { button.disabled = false; }); }
  };
  privacy().then(api => {
    const consent = api.currentVisitorConsent();
    const unset = ['analytics', 'marketing', 'preferences'].every(key => !consent[key]);
    const nativeBanner = window.privacyBanner || document.querySelector('#shopify-pc__banner');
    if (api.shouldShowBanner() && unset && !nativeBanner) banner.hidden = false;
  }).catch(() => {});
  document.addEventListener('visitorConsentCollected', () => { banner.hidden = true; });
  const copyLink = async () => {
    const canonical = document.querySelector('link[rel="canonical"]')?.href || location.origin + location.pathname;
    const url = new URL(canonical);
    const variant = new URL(location.href).searchParams.get('variant');
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
    try {
      await navigator.clipboard.writeText(url.href);
      tools.close();
      say(messages.copied);
    } catch (_) {
      showDialog(tools);
      const box = document.querySelector('[data-bb-copy-fallback]');
      box.hidden = false;
      const input = box.querySelector('input');
      input.value = url.href;
      input.focus();
      input.select();
      say(messages.copy_error);
    }
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('button,a');
    if (!target) return;
    if (target.matches('[data-bb-open-tools]')) showDialog(tools, target);
    if (target.matches('[data-bb-close]')) target.closest('dialog').close();
    if (target.matches('[data-bb-dark]')) {
      const dark = root.dataset.bbColor !== 'dark';
      root.dataset.bbColor = dark ? 'dark' : 'light';
      try { localStorage.setItem('bb-appearance', root.dataset.bbColor); } catch (_) {}
      syncAppearance();
      say(dark ? messages.dark_enabled : messages.light_enabled);
    }
    if (target.matches('[data-bb-top]')) {
      getScrollRoot().scrollTo({ top: 0, behavior: reduced.matches ? 'instant' : 'smooth' });
      const main = document.querySelector('main');
      main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }
    if (target.matches('[data-bb-copy]')) copyLink();
    if (target.matches('[data-bb-print]')) { tools.close(); window.print(); }
    if (target.matches('[data-bb-cookies]')) showPreferences(target);
    if (target.matches('[data-bb-consent-action]')) saveConsent(target.dataset.bbConsentAction);
    if (target.matches('[data-bb-password]')) {
      const input = document.getElementById(target.dataset.bbPassword);
      const show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      target.setAttribute('aria-pressed', String(show));
      target.querySelector('span').textContent = show ? messages.hide_password : messages.show_password;
    }
    if (target.tagName === 'A' && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && !target.hasAttribute('download') && (!target.target || target.target === '_self')) {
      const url = new URL(target.href, location.href);
      if (url.origin === location.origin && url.pathname !== location.pathname && !target.closest('dialog')) {
        loading.hidden = false;
        clearTimeout(loadingTimer);
        loadingTimer = setTimeout(() => { loading.hidden = true; }, 8000);
      }
    }
  });
  const enhancePasswords = () => {
    document.querySelectorAll('input[type="password"]:not([data-bb-enhanced])').forEach((input, index) => {
      input.dataset.bbEnhanced = 'true';
      if (!input.id) input.id = `bb-password-${Date.now()}-${index}`;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bb-password-toggle';
      button.dataset.bbPassword = input.id;
      button.setAttribute('aria-controls', input.id);
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></svg><span></span>';
      button.querySelector('span').textContent = messages.show_password;
      input.insertAdjacentElement('afterend', button);
    });
  };
  enhancePasswords();
  const observer = new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('input[type=password]') || node.querySelector?.('input[type=password]'))))) enhancePasswords(); });
  observer.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll('.contact-form__form').forEach(form => {
    const status = document.createElement('p');
    status.className = 'bb-form-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.append(status);
    let timer;
    const reset = () => { form.removeAttribute('aria-busy'); clearTimeout(timer); };
    form.addEventListener('invalid', () => { status.dataset.error = 'true'; status.textContent = messages.form_invalid; }, true);
    form.addEventListener('input', () => { if (!form.hasAttribute('aria-busy')) status.textContent = ''; });
    form.addEventListener('submit', event => {
      if (form.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
      if (!navigator.onLine) { event.preventDefault(); status.dataset.error = 'true'; status.textContent = messages.form_offline; return; }
      setTimeout(() => {
        if (event.defaultPrevented) return;
        form.setAttribute('aria-busy', 'true');
        status.dataset.error = 'false';
        status.textContent = messages.form_sending;
        timer = setTimeout(() => { reset(); status.dataset.error = 'true'; status.textContent = messages.form_slow; }, 20000);
      }, 0);
    });
    window.addEventListener('pageshow', () => { reset(); status.textContent = ''; });
  });
  window.addEventListener('pageshow', () => { loading.hidden = true; scheduleScroll(); });
  const openDetails = [];
  window.addEventListener('beforeprint', () => { document.querySelectorAll('main details:not([open])').forEach(el => { openDetails.push(el); el.open = true; }); });
  window.addEventListener('afterprint', () => { openDetails.splice(0).forEach(el => { el.open = false; }); });
})();
